// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Language_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'm23.17 19.914-5.25-10.5a.75.75 0 0 0-1.341 0l-2.036 4.072a8.25 8.25 0 0 1-4.418-1.586A9.72 9.72 0 0 0 12.721 6H15a.75.75 0 0 0 0-1.5H9.75V3a.75.75 0 0 0-1.5 0v1.5H3A.75.75 0 0 0 3 6h8.215A8.23 8.23 0 0 1 9 10.908a8.2 8.2 0 0 1-1.781-2.906.75.75 0 1 0-1.414.5 9.7 9.7 0 0 0 2.07 3.404A8.2 8.2 0 0 1 3 13.5.75.75 0 0 0 3 15a9.7 9.7 0 0 0 6-2.07 9.77 9.77 0 0 0 4.823 1.998l-2.494 4.986a.75.75 0 0 0 1.341.672L13.963 18h6.573l1.293 2.586A.75.75 0 0 0 22.5 21a.75.75 0 0 0 .67-1.086ZM14.713 16.5l2.537-5.073 2.536 5.073Z',
  viewBox: '0 0 24 24',
  glyph: 'Language_Stroke2_Corner2_Rounded',
})
